import { Link } from "react-router-dom"
import { Facebook, Instagram, Twitter, Mail, Phone, MapPin, Zap, Youtube, MessageCircle } from "lucide-react"

export function Footer() {
  return (
    <footer className="relative bg-muted/40 border-t border-border/60">
      <div className="container mx-auto px-4 lg:px-8 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-10">
          {/* Marca */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center gap-2 group">
             <div className="w-10 h-10 rounded-xl overflow-hidden flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
  <img
    src="/images/logo.png"
    alt="Rapyfact"
    className="w-full h-full object-contain"
  />
</div>

              <span className="text-2xl font-bold bg-gradient-to-r from-primary to-blue-400 bg-clip-text text-transparent">
                Rapyfact
              </span>
            </Link>

            <p className="text-sm text-muted-foreground leading-relaxed">
              Solución integral de facturación electrónica y validación RIPS para el sector salud en Colombia. Cumplimiento garantizado con la normativa DIAN.
            </p>

            <div className="flex gap-3">
              <a
                href="https://www.facebook.com/p/Rapyfact-Facturaci%25C3%25B3n-Electr%25C3%25B3nica-y-RIPS-Salud-61574604166518"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="w-10 h-10 rounded-lg bg-background border border-border flex items-center justify-center hover:border-primary hover:text-primary transition-all duration-300"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://instagram.com/rapyfact"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-10 h-10 rounded-lg bg-background border border-border flex items-center justify-center hover:border-primary hover:text-primary transition-all duration-300"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://www.youtube.com/@Rapyfact"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="w-10 h-10 rounded-lg bg-background border border-border flex items-center justify-center hover:border-primary hover:text-primary transition-all duration-300"
              >
                <Youtube className="w-5 h-5" />
              </a>
              <a
  href="https://wa.me/573135909091"
  target="_blank"
  rel="noopener noreferrer"
  aria-label="WhatsApp"
  className="w-10 h-10 rounded-lg bg-background border border-border flex items-center justify-center hover:border-green-500 hover:text-green-500 transition-all duration-300"
>
  <MessageCircle className="w-5 h-5" />
</a>

            </div>
          </div>

          {/* Producto */}
          <div className="space-y-6">
            <h3 className="text-lg font-bold">Producto</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/servicios" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Servicios
                </Link>
              </li>
              <li>
                
                  <a
                  href="https://app.rapyfact.com/app/plans"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Planes
                </a>
                
              </li>
              <li>
                <a
                  href="https://app.rapyfact.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  Plataforma
                </a>
              </li> 
              <li>
              <Link to="/videos" className="text-sm text-muted-foreground hover:text-primary transition-colors">
              Videos
            </Link>
            </li>
            <Link
              to="/Recursos"
              className="text-sm text-muted-foreground hover:text-primary transition-colors">
              Recursos
            </Link>
          </ul>
            
          </div>

          {/* Empresa */}
          <div className="space-y-6">
            <h3 className="text-lg font-bold">Empresa</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/sobre-nosotros" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Sobre Nosotros
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Contacto
                </Link>
              </li>
              {/* <li>
                <Link to="/blog" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  Blog
                </Link>
              </li>*/}
              
            </ul>
          </div>

          {/* Contacto */}
          <div className="space-y-6">
            <h3 className="text-lg font-bold">Contacto</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                <a
                  href="mailto:soporte@rapyfact.com"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  soporte@rapyfact.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                <a
                  href="tel:+573135909091"
                  className="text-sm text-muted-foreground hover:text-primary transition-colors"
                >
                  +57 313 590 9091
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                <span className="text-sm text-muted-foreground">Carrera 92 #8A-76, Bogotá - Colombia</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Sección inferior */}
        <div className="mt-16 pt-8 border-t border-border/60 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} Valerosas Tech S.A.S — Rapyfact. Todos los derechos reservados.
          </p>
          <div className="flex flex-wrap justify-center gap-6 text-sm text-muted-foreground">
            <Link to="/politica-privacidad" className="hover:text-primary transition-colors">
              Privacidad
            </Link>
            <Link to="/politica-cookies" className="hover:text-primary transition-colors">
              Cookies
            </Link>
            <Link to="/terminos-condiciones" className="hover:text-primary transition-colors">
              Términos
            </Link>
            <Link to="/aviso-legal" className="hover:text-primary transition-colors">
              Aviso Legal
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
